import { ExternalLink } from "@octopusdeploy/design-system-components";
import type * as React from "react";
import { buildServerPackagingInstruction } from "../../Instructions";
import { CommonBuildServerPackagingTextForIntegration, CommonTextForOctopusCli } from "../CommonRegistrationText";
export const BuildServerPackaging: React.FC<{}> = () => (<div>
        <p>
            When packaging Node.js applications from build servers, we recommend using the <ExternalLink href={"cli"}>Octopus CLI</ExternalLink>.
        </p>
        {CommonTextForOctopusCli}
        {CommonBuildServerPackagingTextForIntegration}
        <p>
            The <ExternalLink href="GuidesNodejs">Node.js guides</ExternalLink> provide step by step instructions for deploying Node.js applications.
        </p>
    </div>);
BuildServerPackaging.displayName = "BuildServerPackaging"
export default buildServerPackagingInstruction(() => <BuildServerPackaging />);
